<template>
    <vx-card id="negotiation-social-security">
        <div class="vx-col mt-3 red-border" style="display:inline-block" v-if="coverageChartPack" >

            <div class="pb-2 pt-1 mt-2" id="titles">
                <img src="../../../../assets/images/pages/eCommerce/umbrella.png">
                <span class="packName mt-2">Pack de Previsión</span><br>
                <span class="packPrimaModified" :style="{color: (calculated == true)  ? 'rgba(var(--vs-secundary))' : 'rgba(var(--vs-danger))'}">{{this.receipt.toFixed(2).replace('.',',')}}</span>
                <span class="packUnits"> €/{{getPaymentMethod(commercialOffer.paymentMethod)}}</span>
                <span class="orientative mt-2" :style="{visibility: (calculated == true)  ? 'hidden' : 'visible'}"> Precio orientativo</span>
                
                <div class="slider mt-2 mb-5">
                    <vs-slider
                        v-model="percentage"
                        ticks step="1"
                        @change="modifyFrontCapitals()"
                        >
                    </vs-slider>
                </div>

            </div>
            
            <div style="table">
                <div class="vx-row mt-1 table-row product">
                    <div class="vx-col benefit" style="font-weight:bold">
                        <span> Prestaciones </span>
                    </div>
                    <div class="vx-col capital" style="font-weight:bold">

                        <span> Capital</span>
                    </div>
                </div>

                <div class="vx-row mt-1 table-row product" :key="index" v-for="(tr, index) in coverageChartPack">

                    <div class="vx-col benefit" :data="coverageChartPack[index].cover" style="float:left">
                        {{coverageChartPack[index].cover}}
                    </div>
                    <div class="vx-col capital" style="display:inline;" :data="coverageChartPack[index].capital">
                        {{formatImporte(coverageChartPack[index].capital)}}
                    </div>
                    <!-- <div class="vx-col slider" style="display:inline; float:right" :key="indexSlider" v-for="(trSlider, indexSlider) in sliderCovers">
                        <div class="vx-row" v-if="coverageChartPack.packOffer[0].capitalOffer[index].cover == sliderCovers[indexSlider].cover" >

                            <slider
                                v-bind:coverageBenefit="coverageChartPack.packOffer[0].capitalOffer[index]"
                                v-bind:sliderCovers="sliderCovers[indexSlider]"
                                v-bind:dividedCoverages="dividedCoverages"
                                @formReturned = "recalculate"
                                >
                            </slider>


                        </div>
                    </div> -->

                </div>
            </div>


            <div class="info-interested-div ">
            <!-- Important the order of buttons, as direction is row-reverse: izq a dcha 
            To avoid movement of buttons when i button not showed  -->
                <vs-button
                    :style="{display: (calculated == false)  ? 'none' : 'inline'}"
                    class="rounded-button right-button"
                    :disabled="calculated == false"
                    @click="goToThirdStep()"
                    >
                    <!-- id="contractButton" -->
                    Me interesa
                </vs-button>

                <vs-button
                    :style="{display: (calculated == true)  ? 'none' : 'inline'}"
                    class="rounded-button right-button"
                    :disabled="calculated == true"
                    @click="recalculate()"
                    >
                    Validar
                </vs-button>

                <vs-button
                    :style="{display: (calculated == false)  ? 'none' : 'inline'}"
                    class="rounded-button left-button"
                    @click="reverse()"
                    >
                    <!-- :disabled="calculated == false" -->
                    <!-- :style="{display: (calculated == false)  ? 'none' : 'inline'}" -->
                    Gráfico de cobertura
                </vs-button>

            </div>
        </div>

        <navegation-buttons id="buttons"
            v-bind:code="code"
            v-bind:previus="previus">
        </navegation-buttons>

            <!-- <vs-popup  class="con-vs-popup bg-box-gradient-popup"  title="¿Hablamos?" :active.sync="callServicePopup">
                <call-service-popup
                    v-bind:callServicePopup="callServicePopup"
                    v-bind:callServiceType="callServiceType"
                    @closeCallServicePopup="closeCallServicePopup"
                >
                </call-service-popup>
            </vs-popup> -->
        <!-- <div id="buttons-2" class="form-width" style="display:inline-block">
            <div  class="box-buttons mt-10">
                <div class="back-button no-fill-button">
                    <vs-button
                    class="vs-button previous-product"
                    @click="goToPreviusStep()"
                    >
                    Anterior
                    </vs-button>
                </div>
                <div class="call-button no-fill-button">
                    <vs-button
                        @click="callService()"
                    >
                    <img src="../../../../assets/images/logo/call-phone-icon.png" width="15px" height="15px"/>
                        Solicitar llamada
                    </vs-button>
                </div>
            </div>
        </div> -->

    </vx-card>
</template>

<script>
/* eslint-disable */
import VxCard from '../../../../components/vx-card/VxCard.vue'
import NavegationButtons from '../navegationButtons/NavegationButtons.vue'

// import CallServicePopup from '../../../components/eprevision-components/callServicePopup/CallServicePopup.vue';
// import Slider from '../slider/Slider.vue'


export default {
  components: {
      VxCard,
      NavegationButtons
    //   CallServicePopup,
    //   Slider
    },
    props: {
        code: String,
        next: String,
        previus: String,
    },
    data() {
      return {
        // callServiceType:"helpProcess",
        // callServicePopup: false,
        receipt: 0,
        dataStored: null,
        coverageChart: {
            name: "",
            coverages: [],
        },
        coverageChartPack: [],
        commercialOffer: null,
        initialCoverageChart: null,
        initialCoverageChartPack: null,
        initialOffer: null,
        recalculatedOffer: null,
        percentage: null,
        initialReceipt: 0,
        calculated: false,

      }
    },
    created() {
        this.$vs.loading.close()
        this.dataStored = JSON.parse(localStorage.getItem(this.code))
        this.commercialOffer = this.dataStored.commercialOffer

        if (this.dataStored.negotationData != null) {
            this.initialOffer = this.dataStored.initialOffer.initialOffer
            this.initialCoverageChart = this.dataStored.initialOffer.initialCoverageChart
            this.initialCoverageChartPack = this.dataStored.initialOffer.initialCoverageChartPack
            this.initialReceipt = this.dataStored.initialOffer.initialReceipt

            this.coverageChart = this.dataStored.negotationData.coverageChart
            this.coverageChartPack = this.dataStored.negotationData.coverageChartPack
            this.recalculatedOffer = this.dataStored.negotationData.recalculatedOffer
            this.receipt = this.dataStored.negotationData.receipt

            this.percentage =  this.dataStored.negotationData.percentage
            this.calculated = true
        } else {
            this.initialCoverageChart = this.dataStored.initialOffer.initialCoverageChart
            this.percentage = 100
            this.initView()
        }

    },

    methods: {

        initView() {
            let commercialOfferData = {
                profession: this.dataStored.initialData.profession,
                bornDate: this.dataStored.initialData.age,
                regime: this.dataStored.initialData.regime,
                paymentType: this.dataStored.commercialOffer.paymentMethod,
                commercialOfferCode: this.code,
                covers: this.initialCoverageChart.coverages
            }

            this.$http.post(process.env.VUE_APP_BROKER_API + '/commercialOffer-packs', commercialOfferData)
            .then((response) => {

                this.initialOffer = response.data
                
                // Used parse & stringify to avoid mutating the original data (initialOffer)
                this.initialReceipt = JSON.parse(JSON.stringify(this.initialOffer.coversResult[0].receipt))
                this.receipt = JSON.parse(JSON.stringify(this.initialOffer.coversResult[0].receipt))
            });

            this.$http.post(process.env.VUE_APP_BROKER_API + '/coverage-chart-pack', this.initialCoverageChart)
            .then((response) => {
                this.initialCoverageChartPack = response.data.packOffer[0]

                this.initialCoverageChartPack.capitalOffer.forEach(capital => {
                    // Used parse & stringify to avoid mutating the original data (initialCoverageChart)
                    // If not used, both initial & coverageChartPack change
                    this.coverageChartPack.push(JSON.parse(JSON.stringify(capital)))
                })

                this.calculated = true

            });

            
            this.initialCoverageChart.coverages.forEach(cover => {
                if(cover.capital) {
                    this.coverageChart.coverages.push(cover) 
                    }
            })
            this.coverageChart.name = this.initialCoverageChart.name

        },

        modifyFrontCapitals() {

            this.coverageChartPack.forEach(cover => {
                let initialCapital = this.initialCoverageChartPack.capitalOffer.filter(x => x.cover == cover.cover)[0].capital
                cover.capital = initialCapital * this.percentage/100
            })

            this.receipt = this.initialReceipt * this.percentage/100

            this.calculated = false

        },

        recalculate() {

            this.coverageChart = {
                coverages: [],
                name: "",
            }

            this.initialCoverageChart.coverages.forEach(cover => {

                let newData = {
                    capital: parseInt(cover.capital * this.percentage/100),
                    coverCode: cover.coverCode,
                    product: cover.product,
                    productId: cover.productId,
                    productName: cover.productName,
                }

                this.coverageChart.coverages.push(newData)
            })

            this.coverageChart.name = this.code

            let data = {
                profession: this.dataStored.initialData.profession,
                bornDate: this.dataStored.initialData.age,
                regime: this.dataStored.initialData.regime,
                paymentType: this.dataStored.commercialOffer.paymentMethod,
                commercialOfferCode: this.code,
                covers: this.coverageChart.coverages
            }

            // let recalculatedReceipt = null
            this.$http.post(process.env.VUE_APP_BROKER_API + '/commercialOffer-packs', data)
            .then((response) => {

                this.recalculatedOffer = response.data

                // Used parse & stringify to avoid mutating the original data (recalculatedOffer)
                // If not used, both initial & recalculatedOffer change
                this.receipt = JSON.parse(JSON.stringify(this.recalculatedOffer.coversResult[0].receipt))
            });


            this.$http.post(process.env.VUE_APP_BROKER_API + '/coverage-chart-pack', this.coverageChart)
            .then((response) => {
                this.recalculatedCoverageChartPack = response.data
                this.coverageChartPack = []
                this.recalculatedCoverageChartPack.packOffer[0].capitalOffer.forEach(capital => {
                    this.coverageChartPack.push(capital)
                })

                this.calculated = true
            });

        },

        goToThirdStep() {
            this.$vs.loading({ type: "sound" });

            // Struct to parse data for endPoint
            let packSelected = {
                commercialOfferCode: this.commercialOffer.code,
                commercialOfferType: this.commercialOffer.type,
                leadType: "SocialSecurity",
                profession: this.dataStored.initialData.profession,
                regime: this.dataStored.initialData.regimeSelectevd, 
                primaTotal: 0,
                primaNeta: 0,
                packCovers: []
            }

            // Parse Data into packCovers for endpoint
            this.coverageChart.coverages.forEach(cover =>{

                let coverData = {
                    capital: "",
                    coverCode: "",
                    cover: "",
                    productCover: "",
                    productName: "",
                }

                coverData.capital = cover.capital
                coverData.coverCode = cover.coverCode
                coverData.productCover = cover.productId + "_" + cover.coverCode
                coverData.productName = cover.productName

                if (this.commercialOffer.accidentProductsInfo.filter(x => x._id == cover.productId)[0]) {

                    let coversProductInfo = this.commercialOffer.accidentProductsInfo.filter(x => x._id == cover.productId)[0]
                    coverData.cover = coversProductInfo.coberturas.filter(y => y.codigo == cover.coverCode)[0].nombre

                } else if (this.commercialOffer.iTProductsInfo.filter(x => x._id == cover.productId)[0]){

                    let coversProductInfo = this.commercialOffer.iTProductsInfo.filter(x => x._id == cover.productId)[0]
                    coverData.cover = coversProductInfo.coberturas.filter(y => y.codigo == cover.coverCode)[0].nombre

                } else if (this.commercialOffer.lifeProductsInfo.filter(x => x._id == cover.productId)[0]) {

                    let coversProductInfo = this.commercialOffer.lifeProductsInfo.filter(x => x._id == cover.productId)[0]
                    coverData.cover = coversProductInfo.coberturas.filter(y => y.codigo == cover.coverCode)[0].nombre

                }

                packSelected.packCovers.push(coverData)
            })

            
            if (this.percentage != 100) {
                
                packSelected.primaTotal = this.recalculatedOffer.coversResult[0].primaTotal
                packSelected.primaNeta = this.recalculatedOffer.coversResult[0].primaNeta

            } else {
                
                packSelected.primaTotal = this.initialOffer.coversResult[0].primaTotal
                packSelected.primaNeta = this.initialOffer.coversResult[0].primaNeta

            }

            let data = {
                coverageChart: this.coverageChart,
                coverageChartPack: this.coverageChartPack,
                recalculatedOffer: this.recalculatedOffer,
                receipt: this.receipt,
                percentage: this.percentage,
                productsSelected: this.getProductsSelected()
            }

            this.dataStored.negotationData = data
            this.dataStored.initialOffer.initialReceipt = this.initialReceipt
            this.dataStored.initialOffer.initialCoverageChartPack = this.initialCoverageChartPack
            this.dataStored.initialOffer.initialOffer = this.initialOffer

            // var windowReference = window.open();

            this.$http.patch(process.env.VUE_APP_BROKER_API + '/initial-data/' + this.dataStored.initialData.initialDataId, packSelected)
            .then((response) => {

                localStorage.setItem(this.code, JSON.stringify(this.dataStored))
                this.$router
                .push("/" + this.next + "-step/" + this.code)
                .catch(() => {});
                
                // this.closeLoader = setInterval(async () => {
                //     this.localDataStored = JSON.parse(localStorage.getItem(this.code))
                //     if (this.localDataStored.signed == true)  {
                //         // Delete localStorage 
                //         localStorage.removeItem(this.code);

                //         this.$vs.loading.close()
                //         clearInterval(this.closeLoader)
                //         this.$router
                //             .push("/" +  this.code)
                //             .catch(() => {});
                //         }
                
                // }, 15000)
                // Changed as the window.open was blocked in IOS 
                // windowReference.location = process.env.VUE_APP_DOMAIN + '/' + this.next + '-step/' + this.code;
                   
                // window.open(process.env.VUE_APP_DOMAIN + '/' + this.next + '-step/' + this.code, '_blank');

            })

        },

        goToDonuts(){
            if (this.calculated == false) {
                this.recalculate()
                this.reverse()
                
            } else {
                this.reverse()
            }
        },

        reverse(){
            if (this.calculated == true) {
                // this.parseIntoLocalStorage()

                let localData = {
                    coverageChart: this.coverageChart,
                    coverageChartPack: this.coverageChartPack,
                    recalculatedOffer: this.recalculatedOffer,
                    receipt: this.receipt,
                    percentage: this.percentage,
                    // productsSelected: this.getProductsSelected()
                }

                this.dataStored.negotationData = localData
                this.dataStored.initialOffer.initialReceipt = this.initialReceipt
                this.dataStored.initialOffer.initialCoverageChartPack = this.initialCoverageChartPack
                this.dataStored.initialOffer.initialOffer = this.initialOffer

                let data = {
                    widowhood: 0,
                    orphanhood: 0,
                    orphanhoodCapital: 0,
                    needOrphanhoodCapital: 0, 
                    childrenAges: this.dataStored.initialData.socialSecurityInput.childrenAges,
                    age: this.dataStored.initialData.age,
                    ageSpouse: this.dataStored.initialData.socialSecurityInput.ageSpouse,
                    covers: this.coverageChart.coverages,
                    totalIncome: this.dataStored.clientsNeeds.salaryMonth*12,
                }

                if(this.dataStored.clientsNeeds.clientsCapitals.filter(x => x.name == "Orfandad")[0]){
                    let value = this.dataStored.clientsNeeds.clientsCapitals.filter(x => x.name == "Orfandad")[0]
                    data.needOrphanhoodCapital = value.need * this.percentage/100
                    data.orphanhoodCapital = value.social
                    data.orphanhood = this.dataStored.needsCapitals.orphanhood * this.percentage/100
                }

                if(this.dataStored.clientsNeeds.clientsCapitals.filter(x => x.name == "Viudedad")[0]){
                    data.widowhood = this.dataStored.needsCapitals.widowhood * this.percentage/100
                }


                this.$http.post(process.env.VUE_APP_BROKER_API + '/capital-distribution/reverse', data)
                .then((response) => {
                    this.dataStored.reverseData = response.data
                    localStorage.setItem(this.code, JSON.stringify(this.dataStored))

                    this.$router
                        .push( '/social-security/results-step/' + this.code)
                        .catch(() => {});
                    });
            }

        },

        getProductsSelected(){
            let productsSelected = []
            
                this.coverageChart.coverages.forEach(coverage =>{
                    if(coverage.capital != null && productsSelected.includes(coverage.product) == false){
                        productsSelected.push(coverage.product)
                    }
                })

            return productsSelected
        },

        formatImporte(importe){
            if(!isNaN(importe)){
              return importe.toFixed(0).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.") + ' €'
            }
            return importe;
          },

          getPaymentMethod(payment){
           let paymentMethod = ""
           switch(payment){
               case 1:
                   paymentMethod = "año"
                break;

               case 2:
                paymentMethod = "semestre"
                break;

               case 3:
                paymentMethod = "cuatrimestre"
                break;

               case 4:
                paymentMethod = "trimestre"
                break;

               case 6:
                paymentMethod = "bimensual"
                break;

               case 12:
                paymentMethod = "mes"
                break;
           }
           return paymentMethod
       },

        // goToPreviusStep() {
        //     this.$router
        //     .push("/"+ this.previus + "-step/" + this.code )
        //     .catch(() => {});

        // },

        // callService() {
        //     this.callServicePopup = true;
        // },

        // closeCallServicePopup(value){
        //     this.callServicePopup = value;
        // },

    },

}
</script>

 <style lang="scss">

#negotiation-social-security {

    .packPrimaModified{
        padding-top:10px !important;
        font-family: "Montserrat", Helvetica, Arial, sans-serif;
        opacity: 0.7;
        font-size: 30px;
        font-weight: 420
        }

    .orientative {
        font-family: "Montserrat", Helvetica, Arial, sans-serif;
        display: block;
        opacity: 0.7;
        font-size: 14px;
        font-weight: 520;
        margin: auto;
        }

    .con-vs-slider{
            width: 50%;
            margin: auto;
        }

    .product {
        padding-left: 20px;
        padding-right: 20px;
    }

    #titles {
        img{
            width: 70px;
            height: 70px;
            display:block;
            margin:auto;
            }
    }

    .packName{
        line-height: 12px !important;
        font-weight: 530;
        font-size: 17px;
        display:block;
        margin:auto;
    }

    .form-width {
            width: 100%
        }

    .table{
        display: flex !important;
        flex-direction: column;
        flex-wrap: wrap;
        align-content: space-around;
        justify-content: space-between;
        align-items: stretch !important;
    }

    .table-row{
        display: flex !important;
        flex-direction: row;
        flex-wrap: nowrap;
        align-content: space-around;
        justify-content: space-between;
        align-items: center !important;
    }


    .slider {
        text-align:center;
        margin: auto;
    }
    
    .benefit{
        width: 80%;
        justify-items: start;
        text-align:left;
        padding-left: 15px;
        padding-right: 0px;
        overflow-wrap: break-word !important;
    }

    // #contractButton {
    //     display: inline;
    //     padding: 5px 10px !important;
    //     background: none;
    //     color: rgba(var(--vs-secundary), 1) !important;
    //     border: 1px solid rgba(var(--vs-secundary), 1) !important;
    //     font-weight: bold;
    //     border-radius: 18px;
    //     float: right !important;
    //     font-size: 12px !important;
    //     margin-top: 20px !important;
    //     margin-right:30px !important;
    //     margin-bottom:20px !important;
    //     height: 40px;

    // }

    
    // #goToDonuts {
    //     display: inline;
    //     padding: 5px 10px !important;
    //     background: none;
    //     color: rgba(var(--vs-secundary), 1) !important;
    //     border: 1px solid rgba(var(--vs-secundary), 1) !important;
    //     font-weight: bold;
    //     border-radius: 18px;
    //     font-size: 12px !important;
    //     height: 40px;
    //     float: left !important;
    //     margin-top: 20px !important;
    //     margin-left:30px !important;
    //     margin-bottom:20px !important;

    // }


    @media only screen and (max-width: 300px) {

        .info-interested-div {
            display: flex;
            flex-direction: column;
            flex-wrap: nowrap;
            justify-content: space-around;
            align-items: center;
            margin-bottom: 10px !important;
            padding-top: 5px;

            .left-button{
            float: none !important;
            margin-left: 0px !important;
            margin-right: 0px !important;
            margin-top: 10px !important;
            margin-bottom: 10px !important;
            }

            .right-button{
            float: none !important;
            margin-left: 0px !important;
            margin-right: 0px !important;
            margin-bottom: 10px !important;
            margin-top: 0px !important;
            }
        }
    } 

    @media only screen and (max-width:400px) {
        
            // #goToDonuts {
            //     float: center !important;
            // }
        .left-button{
            margin-left:15px !important;
        }
        .right-button {
            margin-right: 15px !important;
        }

        .con-vs-slider{
            width: 30%;
            margin: auto;
            min-width: 150px;
        }

        .benefit{
            width: 60%;
            // max-width: 100px;
            text-align:left;
            padding-left: 0px;
            padding-right: 0px;
            overflow-wrap: break-word !important;
        }
        .capital{
            max-width: 30%;
            white-space:nowrap;
            display: flex !important;
            margin-left: 1px;
        }

        .vx-row .vx-col{
            padding: 0px 0px;
        }
    }

    @media only screen and (max-width: 600px) {
        // .call-button{
        //     .vs-button{
        //         float: center !important;
        //     }
        // }

        .benefit{
            width: 60%;
            // max-width: 100px;
            text-align:left;
            padding-left: 0px;
            padding-right: 0px;
            overflow-wrap: break-word !important;
        }
        .capital{
            max-width: 30%;
            white-space:nowrap;
        }

    }

    @media only screen and (min-width: 601px) {
        // .call-button{
        //         .vs-button{
        //             float: right !important;
        //         }
        //     }
        
        .benefit{
            max-width: 75%;
            overflow-wrap: break-word !important;
        }
        .capital{
            max-width: 30%;
            white-space:nowrap;
        }

 }

}

</style>